"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBoardFromPacket = updateBoardFromPacket;
function updateBoardFromPacket(board, pieceRegistry, packet) {
    board.clear();
    board.setPieces(Object.entries(packet.positions).map(([position, pieceId]) => {
        const [x, y] = position.split(",").map(Number);
        return { id: pieceId, x, y };
    }));
    for (const piece of packet.pieces) {
        pieceRegistry.registerPiece(piece);
    }
}
